/**
 * In-memory flight list cache (cleared on full page reload).
 * Keys: API path + normalized Date — matches CaseFileController / TransferBagController (Date Y-m-d).
 */

const store = new Map();
const pending = new Map();

function dateKey(data) {
  if (!data || data.Date == null || data.Date === "") {
    return null;
  }
  const s = String(data.Date);
  const isoDay = s.match(/^(\d{4}-\d{2}-\d{2})/);
  return isoDay ? isoDay[1] : s.slice(0, 10) || null;
}

/**
 * @param {string} endpoint Relative path e.g. "caseFiles/getArrivalFlightList"
 * @param {object} data Request body (uses data.Date)
 * @param {function(object): Promise<any>} fetcher
 */
export function withFlightDateCache(endpoint, data, fetcher) {
  const dk = dateKey(data);
  if (!dk) {
    return fetcher(data);
  }
  const key = `${endpoint}:${dk}`;
  if (store.has(key)) {
    return Promise.resolve(store.get(key));
  }
  if (pending.has(key)) {
    return pending.get(key);
  }
  const promise = fetcher(data)
    .then((res) => {
      store.set(key, res);
      pending.delete(key);
      return res;
    })
    .catch((err) => {
      pending.delete(key);
      throw err;
    });
  pending.set(key, promise);
  return promise;
}
